import {
  CAMERA_SET_GRID,
  CAMERA_SET_DATA,
  CAMERA_SET_DATA_ALL,
  CAMERA_SET_LAST_PAGE,
  CAMERA_SET_TOTAL_ROWS,
  CAMERA_SET_CURRENT_ROW,
  CAMERA_SET_RELOAD_DATA,
  CAMERA_SET_LOADING,
  CAMERA_SET_LOADING_ALL,
  CAMERA_TOGGLE_CREATE_EDIT_MODAL,
  CAMERA_TOGGLE_DELETE_MODAL,
  CAMERA_SET_MQTT_CAMERAS_STATUS,
} from './enums/CameraTypes';

const initialState = {
  grid: {
    data: [],
    lastPage: 0,
    totalRows: 0,
    reloadData: 0,
    loading: false,
  },
  dataAll: [],
  currentRow: {},
  createEditModal: false,
  deleteModal: false,
  loadingAll: false,
  mqttCamerasStatus: {
    online: 0,
    offline: 0,
  },
};

const CameraReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAMERA_SET_GRID:
      return { ...state, grid: action.data };
    case CAMERA_SET_DATA:
      return { ...state, grid: { ...state.grid, data: action.data } };
    case CAMERA_SET_DATA_ALL:
      return { ...state, dataAll: action.data };
    case CAMERA_SET_TOTAL_ROWS:
      return { ...state, grid: { ...state.grid, totalRows: action.data } };
    case CAMERA_SET_LAST_PAGE:
      return { ...state, grid: { ...state.grid, lastPage: action.data } };
    case CAMERA_SET_LOADING:
      return { ...state, grid: { ...state.grid, loading: action.value } };
    case CAMERA_SET_LOADING_ALL:
      return { ...state, loadingAll: action.value };
    case CAMERA_SET_RELOAD_DATA:
      return {
        ...state,
        grid: { ...state.grid, reloadData: state.grid.reloadData + 1 },
      };
    case CAMERA_SET_CURRENT_ROW:
      return { ...state, currentRow: action.data };
    case CAMERA_TOGGLE_CREATE_EDIT_MODAL:
      return { ...state, createEditModal: !state.createEditModal };
    case CAMERA_TOGGLE_DELETE_MODAL:
      return { ...state, deleteModal: !state.deleteModal };
    case CAMERA_SET_MQTT_CAMERAS_STATUS:
      return { ...state, mqttCamerasStatus: action.data };
    default:
      return state;
  }
};
export default CameraReducer;
